import PropTypes from 'prop-types';

export const propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    fundType: PropTypes.string,
    apirCode: PropTypes.string,
    isin: PropTypes.string,
    dataProviderId: PropTypes.string,
    stockCode: PropTypes.string,
    inceptionDate: PropTypes.string,
    objective: PropTypes.string,
    geographicalFocus: PropTypes.string,
    investmentHorizon: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
    minimumInvestment: PropTypes.number,
    fundSize: PropTypes.number,
    fundSizeDate: PropTypes.string,
    currency: PropTypes.string,
    legalStructure: PropTypes.string,
    domicile: PropTypes.string,
    investUrl: PropTypes.string,
    fundPageUrl: PropTypes.string,
    pdsFileUrl: PropTypes.string,
    dpPdsFileUrl: PropTypes.string,
    monthlyUpdateFileUrl: PropTypes.string,
    monthlyUpdateUrlType: PropTypes.string,
    tmdFileUrl: PropTypes.string,
    disclaimer: PropTypes.string,
    company: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    fundAssetClass: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    members: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      role: PropTypes.string,
    })),
    featuredWireUrls: PropTypes.arrayOf(PropTypes.string),
    performance: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string,
    })).isRequired,
    managementFee: PropTypes.number,
    performanceFeeCharged: PropTypes.string,
    performanceFeePds: PropTypes.number,
    performanceFee: PropTypes.number,
    performanceFeeMethodology: PropTypes.string,
    totalCostRatio: PropTypes.number,
    financialYearEndFeesDate: PropTypes.string,
    buySpread: PropTypes.number,
    sellSpread: PropTypes.number,
    latestProspectusDate: PropTypes.string,
    dayEndEntryPrice: PropTypes.number,
    dayEndExitPrice: PropTypes.number,
    dayEndNavPrice: PropTypes.number,
    dayEndPricingUpdateDate: PropTypes.string,
    dayEndMarketPrice: PropTypes.number,
    dayEndMarketPriceDate: PropTypes.string,
    dayEndNav: PropTypes.number,
    dayEndNavDate: PropTypes.string,
    dpManagementFee: PropTypes.number,
    dpPerformanceFeePds: PropTypes.number,
    dpPerformanceFee: PropTypes.number,
    dpTotalCostRatio: PropTypes.number,
    dpFinancialYearEndFeesDate: PropTypes.string,
    dpBuySpread: PropTypes.number,
    dpSellSpread: PropTypes.number,
    dpLatestProspectusDate: PropTypes.string,
    dpDayEndEntryPrice: PropTypes.number,
    dpDayEndExitPrice: PropTypes.number,
    dpDayEndNavPrice: PropTypes.number,
    dpDayEndPricingUpdateDate: PropTypes.string,
    dpDayEndMarketPrice: PropTypes.number,
    dpDayEndMarketPriceDate: PropTypes.string,
    dpDayEndNav: PropTypes.number,
    dpDayEndNavDate: PropTypes.string,
    dpFundSize: PropTypes.number,
    dpFundSizeDate: PropTypes.string,
    fundInvestorVehicleType: PropTypes.string,
    wholesale: PropTypes.bool.isRequired,
    series: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })),
    dataReviews: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      current: PropTypes.string,
      toReview: PropTypes.string,
      createdAt: PropTypes.string,
    })).isRequired,
  }),
  questions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    order: PropTypes.number.isRequired,
    category: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    fundTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })).isRequired,
  autoSyncData: PropTypes.bool,
};

export const defaultProps = {
  fund: {
    id: null,
    name: '',
    fundType: '',
    apirCode: '',
    isin: '',
    dataProviderId: '',
    stockCode: '',
    inceptionDate: null,
    objective: '',
    geographicalFocus: '',
    investmentHorizon: '',
    minimumInvestment: null,
    fundSize: null,
    fundSizeDate: null,
    currency: '',
    legalStructure: '',
    domicile: '',
    investUrl: '',
    fundPageUrl: '',
    pdsFileUrl: '',
    dpPdsFileUrl: '',
    monthlyUpdateFileUrl: '',
    monthlyUpdateUrlType: null,
    disclaimer: '',
    company: null,
    fundAssetClass: null,
    members: [],
    series: [],
    featuredWireUrls: [],
    performance: [],
    dpPerformance: [],
    managementFee: null,
    performanceFeeCharge: 'unknown',
    performanceFeePds: null,
    performanceFee: null,
    performanceFeeMethodology: '',
    totalCostRatio: null,
    financialYearEndFeesDate: null,
    buySpread: null,
    sellSpread: null,
    latestProspectusDate: null,
    dayEndEntryPrice: null,
    dayEndExitPrice: null,
    dayEndNavPrice: null,
    dayEndPricingUpdateDate: null,
    dayEndMarketPrice: null,
    dayEndMarketPriceDate: null,
    dayEndNav: null,
    dayEndNavDate: null,
    dpManagementFee: null,
    dpPerformanceFeePds: null,
    dpPerformanceFee: null,
    dpTotalCostRatio: null,
    dpFinancialYearEndFeesDate: null,
    dpBuySpread: null,
    dpSellSpread: null,
    dpLatestProspectusDate: null,
    dpDayEndEntryPrice: null,
    dpDayEndExitPrice: null,
    dpDayEndNavPrice: null,
    dpDayEndPricingUpdateDate: null,
    dpDayEndMarketPrice: null,
    dpDayEndMarketPriceDate: null,
    dpDayEndNav: null,
    dpDayEndNavDate: null,
    dpFundSize: null,
    dpFundSizeDate: null,
    dataReviews: [],
  },
  autoSyncData: false,
};
